import styled from "styled-components";

export const CommentContainer = styled.div`
    display: flex;
    align-items: flex-end;
    margin-top: 8px;
    width: 100%;

    @media (max-width: 768px) {
        margin-top: 6px;
    }
`;

export const CommentCaptionContainer = styled.div`
    background-color: #333443;
    padding: 8px 12px;
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #3a3d4d;
    }

    @media (max-width: 768px) {
        padding: 6px 10px;
        border-radius: 6px;
    }

    &.no-cursor {
        cursor: default;

        &:hover {
            background-color: #333443;
        }
    }
`;

export const CommentCaption = styled.div`
    display: block;
    color: #bcbcbc;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.4;
    word-wrap: break-word;

    @media (max-width: 768px) {
        font-size: 12px;
    }
`;
